// メインスレッド側の検索 Worker ラッパー。Comlink で型付き RPC を張る。

import * as Comlink from 'comlink'
import type { SearchWorkerApi } from './search.worker'

let proxy: Comlink.Remote<SearchWorkerApi> | null = null

export function getSearchWorker(): Comlink.Remote<SearchWorkerApi> {
  if (!proxy) {
    const worker = new Worker(new URL('./search.worker.ts', import.meta.url), {
      type: 'module',
      name: 'inkyo-search',
    })
    proxy = Comlink.wrap<SearchWorkerApi>(worker)
  }
  return proxy
}

export type { WorkerResult, RunResult, RunInput, RhymeMode, ResultFilter, SortOrder } from './search.worker'
